import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateMakeover = createAsyncThunk("ListingMakeover/updateMakeover", async (data, thunkAPI) => {
  let { handleSuccess, handleError } = data;
  try {
    const resp = await axios.put(`${process.env.REACT_APP_BASE_URL}api/transactions/makeover/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
      if(handleSuccess){
        handleSuccess()
      }
    return resp.data;
  } catch (error) {
    if (error.response) {
      if(handleError){
        handleError(error.response.data.errorMessage || error.response.data.message)
      }
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      if(error.message){
        handleError(error.message)
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
